import { HttpErrorResponse } from '@angular/common/http';

export class CustomHttpErrorResponse<T> extends HttpErrorResponse {
  error: T;
}

export interface Error {
  timestamp: string;
  status: number;
  error: string;
  message: string;
  path: string;
}
